import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const EmailBounce = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox="0 0 24 24"
    data-test="icon-email-bounce"
    {...props}
  >
    <path
      d="M10 13C10.8678 13.3047 13.0579 14.1994 13.3902 15.5508"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <path
      d="M16 14.8999C15.3987 15.4975 14.4675 16.7431 14.6582 18.2465"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeDasharray="2 2"
    />
    <circle
      cx="18"
      cy="12.3999"
      r="1.35"
      fill="white"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.3"
    />
    <path
      d="M9.1875 14.8125H4.6875C4.38913 14.8125 4.10298 14.694 3.892 14.483C3.68103 14.272 3.5625 13.9859 3.5625 13.6875V4.6875C3.5625 4.38913 3.68103 4.10298 3.892 3.892C4.10298 3.68103 4.38913 3.5625 4.6875 3.5625H18.1875C18.4859 3.5625 18.772 3.68103 18.983 3.892C19.194 4.10298 19.3125 4.38913 19.3125 4.6875V9.1875"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0581 3.9751L12.9502 8.6731C12.5164 9.00674 11.9846 9.18764 11.4374 9.18764C10.8902 9.18764 10.3584 9.00674 9.92465 8.6731L3.81665 3.9751"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
